// @workflow assistant.attachments
/**
 * The original File of each chat upload, kept in page memory by its attachment id (the id the
 * server gave it), so a UI tool can hand the same file to an app screen (ui.registers.open_import).
 * Plain module memory: never browser storage, gone when the page unloads or reloads. Kept after
 * the message is sent (the tool runs after the send); × on a chip forgets its file.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

const files = new Map();

const keyOf = (id) => (typeof id === 'string' || typeof id === 'number' ? String(id).trim().toLowerCase() : '');

/** Keep `file` under `attachmentId` (ignored without both). */
export function rememberFile(attachmentId, file) {
  const key = keyOf(attachmentId);
  if (key && file) files.set(key, file);
}

/** @returns {File|null} the file of `attachmentId` on this page, if it is still here */
export function fileFor(attachmentId) {
  const key = keyOf(attachmentId);
  return (key && files.get(key)) || null;
}

export function forgetFile(attachmentId) {
  files.delete(keyOf(attachmentId));
}

export function clearFiles() {
  files.clear();
}
